// CSS-only hero backdrop: obsidian base, fading coordinate grid, two drifting brand auroras, scanlines and an
// oversized watermark. No stock photography — the data is the picture.
export default function HeroBackdrop() {
  return (
    <div aria-hidden className="absolute inset-0 pointer-events-none overflow-hidden" data-testid="hero-backdrop">
      <div className="absolute inset-0 hero-grid" />
      <div className="absolute -top-48 -left-40 w-[760px] h-[760px] rounded-full blur-[150px] bg-neon-yellow/[0.17] aurora-a" />
      <div className="absolute -top-32 right-[-12%] w-[680px] h-[680px] rounded-full blur-[150px] bg-neon-cyan/[0.13] aurora-b" />
      <div className="absolute bottom-[-10%] left-[35%] w-[520px] h-[520px] rounded-full blur-[150px] bg-neon-magenta/[0.06]" />
      <div className="absolute inset-0 terminal-scanlines opacity-70" />
      <div className="absolute bottom-[-2vw] left-0 right-0 overflow-hidden whitespace-nowrap select-none font-mono font-black text-[13vw] leading-none tracking-tighter text-white/[0.028]">
        <span className="inline-block marquee-x">DATABASE · OUTREACH · DATABASE · OUTREACH · DATABASE · OUTREACH · DATABASE · OUTREACH · </span>
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/20 to-background" />
    </div>
  );
}
